import Axios from "axios";
import { get } from "lodash";
import React from "react";
import ReactDOM from "react-dom";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { BrowserRouter as Router } from "react-router-dom";
import { BASE_URL } from "utils/endpoints";
import App from "./App";
import "./index.css";
import { getTranslations } from "./translations";
import { shouldSuppressErrorNotification } from "./utils/axios-error-notification";

// Axios global configs

Axios.defaults.baseURL = BASE_URL;

Axios.interceptors.response.use(
    (res) => res,
    (error) => {
        const errorStatus = get(error, ["response", "data", "status"], 400);
        const errorMsg = get(
            error,
            ["response", "data", "message"],
            getTranslations().notification.unexpectedError
        );

        console.log(errorStatus, errorMsg);
        if (!shouldSuppressErrorNotification(error)) {
            NotificationManager.error(errorMsg);
        }

        return Promise.reject(error);
    }
);

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <App />
        </Router>
        <NotificationContainer />
    </React.StrictMode>,
    document.getElementById("root")
);

declare global {
    interface Window {
        // CookieYes Retrieving Consent Data Using getCkyConsent() API - https://www.cookieyes.com/documentation/retrieving-consent-data-using-api-getckyconsent/
        getCkyConsent?: () => {
            categories: { advertisement: boolean };
        };

        //gtag_report_conversion is defined when we implement Google Ads conversion tracking script located in utils/analytics/tracking/trackingScripts.ts
        gtag_report_conversion?: () => void;

        fbq?: (...args: unknown[]) => void;

        lintrk?: (...args: unknown[]) => void;

        uetq?: unknown[];
    }
}
